"use strict";

angular.module("customer")
.controller("incompleteProfileWarning", function($rootScope, $scope, $attrs, close, $state, CUSTOMER_TYPE) {
    $scope.isProfileIncomplete = $attrs.isProfileIncomplete;
    $scope.isCustomerIncomplete = $attrs.isCustomerIncomplete;

    $scope.isCustomerTypeBusiness = $rootScope.user && $rootScope.user.customer && $rootScope.user.customer.type == CUSTOMER_TYPE["BUSINESS"];

    this.goToProfileEdition = function() {
        $state.go("profile-edit", {
            forceModalRedirect: true
        });
        this.close();
    };

    this.goToCustomerEdition = function() {
        $state.go("customer-edit", {
            forceModalRedirect: true
        });
        this.close();
    };

    this.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/full-profile-only/modals/incomplete-profile-warning.modal.js
// module id = 826
// module chunks = 0